import { Box, Icon } from '@redriverpress/system'

import { CompactButton, ListButton } from 'Common/components/viewModeToggle'

import useViewMode from '../hooks/useViewMode'
import { compactView, listView } from '../constants/ui'

export default function ViewModeToggle() {
  const [viewMode, setViewMode] = useViewMode()

  const setListView = () => setViewMode(listView)
  const setCompactView = () => setViewMode(compactView)

  return (
    <Box display='flex'>
      <ListButton onClick={setListView} disabled={viewMode === listView}>
        <Icon icon='list' />
      </ListButton>
      <CompactButton
        onClick={setCompactView}
        disabled={viewMode === compactView}
      >
        <Icon icon='th-large' />
      </CompactButton>
    </Box>
  )
}
